import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TableHeightService {

  delta = 210

  notificationDelta = 190

  supportDelta = 210

  filterBlockHeight$: Subject<number> = new Subject<number>()

  tableHeight$: Subject<string> = new Subject<string>()
  supportHeight$: Subject<string> = new Subject<string>()
  notificationsHeight$: Subject<string> = new Subject<string>()

  constructor() {
    this.filterBlockHeight$.subscribe({
      next: (res) => {
        if (window.innerWidth > 768) {
          const deltaScreen = window.innerHeight - res - this.delta
          const height = `${deltaScreen}px`
          this.tableHeight$.next(height)

          this.notificationsHeight$.next(`${window.innerHeight - res - this.notificationDelta}px`)
        }
      }
    })

    this.filterBlockHeight$.subscribe({
      next: (res) => {
        if (window.innerWidth > 768) {
          const deltaScreen = window.innerHeight - res - this.supportDelta
          const height = `${deltaScreen}px`
          this.supportHeight$.next(height)
        }
      }
    })
  }
}
